import { inject, Injectable } from '@angular/core';
import { SearchRepository } from '@core/services/repositories/search.repository';

@Injectable({
 providedIn: 'root',
})
export class MapService {
 constructor() {}

 searchRepo = inject(SearchRepository);
}
